angular.module('biz-ng-career-details').provider('surveyUIConfiguration', function () {
  var DEFAULTS = {
    enableTalkToAdvisor: true,
    enableAppointmentsScheduling: false,
    enableProgramTimeToCompletionMessage: false,
    enableProgramEstimatedTuition: true,
    enableProgramCredits: true,
    careerDataAttributionMessage:
      '<p class="attribution-message text-sz-s">Our career data includes information from the O*NET&trade; database, version 21.0</p>' +
      '<p class="attribution-message text-sz-s">O*NET&trade; is a trademark of the U.S. Department of Labor, Employment and Training Administration.</p>'
  };

  var configuration = _.merge({}, DEFAULTS);

  var configure = (this.configure = function configure_surveyConfig(config) {
    if (!!config) {
      configuration = _.merge({}, DEFAULTS, config);
    }

    return configuration;
  });

  var read = (this.read = function read_surveyConfiguration() {
    return configuration;
  });

  this.activate = function read_surveyConfiguration(config) {
    this.configure(config);
  };

  this.$get = function () {
    return {
      configure: configure,
      read: read
    };
  };
});



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-career-details/src/config/survey_configuration.js